import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://finance.camclarkgroup.com/api",
  timeout: 60000,
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lies within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    const isLoginRequest = error.config?.url?.includes("/v2/auth");

    // Do not clear MSAL cache or reload during sign-in; that breaks the redirect flow
    if (
      !isLoginRequest &&
      [401, 403].includes(error.response?.status)
    ) {
      localStorage.removeItem("jwt");
      localStorage.removeItem("user");
      sessionStorage.removeItem("jwt");
      sessionStorage.removeItem("user");
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
